import { AnvaQuote } from '@flows/src/types/anva';
import { create } from 'zustand';

interface FlowsProductSelectionStore {
  selectedItems: AnvaQuote[];
  addToSelected: (item: AnvaQuote) => void;
  removeFromSelected: (item: AnvaQuote) => void;
  reset: () => void;
}

const useAnvaFlowProductSelectionStore = create<FlowsProductSelectionStore>(
  (set) => ({
    selectedItems: [],
    addToSelected: (item) =>
      set((state) => ({
        selectedItems: [
          // remove existing `anva_product_id && index` combinations as only one is allowed
          ...state.selectedItems.filter(
            (existingItem) =>
              !(
                existingItem.anva_product_id === item.anva_product_id &&
                existingItem.index === item.index
              ),
          ),
          item,
        ],
      })),
    removeFromSelected: (itemToRemove) =>
      set((state) => ({
        selectedItems: state.selectedItems.filter(
          (item) =>
            !(item.id === itemToRemove.id && item.index === itemToRemove.index),
        ),
      })),
    reset: () =>
      set(() => ({
        selectedItems: [],
      })),
  }),
);

export default useAnvaFlowProductSelectionStore;
